var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CreateChannelModal.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-47d531b0\",\"hasScoped\":false}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CreateChannelModal.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/market/modal/CreateChannelModal.vue
// module id = 1445
// module chunks = 8